"use client";
import Button from "@/components/Cards/Button";
import SmallVideoCard from "@/components/Cards/SmallVideoCard";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import MasterclassStats from "@/components/MasterclassStats";
import InfoModal from "@/components/Modal";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Testimonial from "@/components/Text/Testimonial";
import Text from "@/components/Text/Text";
import Triangles from "@/components/Triangles";
import { ButtonDark, LongButton } from "@/stories/Button.stories";
import { TestemonialBlackImg } from "@/stories/Testemonial.stories";
import type { Video } from "@/types";
import { formatDuration, getModuleVideosWithSub, shuffle } from "@/utils";
import { useState } from "react";
import "react-vertical-timeline-component/style.min.css";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../../public/content/testimonials.json";
import videos from "../../../../public/content/videos.json";
import Newsletter from "@/components/Cards/Newsletter";
import { NewsletterOrange } from "@/stories/Newsletter.stories";
import StatisticCard from "@/components/Statistic/StatisticCard";
import SideBySideText from "@/components/Text/SideBySideText";
import Image from "next/image";
import Timeline from "@/components/Timeline/Timeline";
import HalfCard from "@/components/Cards/HalfCard";
import Title from "@/components/Text/Title";
import { sendGTMEvent } from "@/components/Analytics";

export default function WieSieFunktioniertLayout() {
    const [openModal, setOpenModal] = useState(false);
    const [id, setId] = useState("");
    const [thumbnail, setThumbnail] = useState("");

    const moduleVideosWithSub = getModuleVideosWithSub(
        videos,
        "Modul 4: Die Fernbehandlung",
    );
    const statistics = [
        {
            number: "48",
            text: "Ich benötige keine Informationen von dir, da ich alle notwendigen Daten direkt aus dem Energiefeld lesen kann, vergleichbar mit dem Lesen eines Buches. Es mag erstaunlich klingen, aber tatsächlich werden rund 48% der Fernbehandlungen ohne jegliche vorherige Angaben bestellt.",
            numberColor: "text-greenText",
        },
        {
            number: "3",
            text: "Wusstest du, dass etwa 3% der Fernbehandlungen circa einen Monat dauern? Die überwältigende Mehrheit der Fernbehandlungen ist jedoch längerfristig angelegt.",
            numberColor: "text-yellow",
        },
        {
            number: "74.3",
            text: "Buchen eine Ferhbehandlung, ohne zusätzliche, persönliche Sitzungstermine zu buchen.",
            numberColor: "text-blue",
        },
        {
            number: "0.5",
            text: "Die Geld zurück Garantie ist nicht ganz null, sie liegt im 0.5% Bereich",
            numberColor: "text-zinc-500",
        },
    ];
    const timeline = [
        {
            title: "Exakte Ursachen-Analyse",
            content:
                "Analyse des Energiefeldes mit dem Ziel, die Funktionalität und die Wechselwirkungen zu beurteilen, die Ursachen sowie die daraus resultierenden Symptome zu identifizieren .",
            number: "1",
            bulletColor: "#F6C4BB",
            borderColor: "#F2745D",
        },
        {
            title: "Theoretische Ausführung",
            content:
                "Anhand dieser Analyse beginne ich theoretisch zu simulieren, wie dass sich meine Arbeit auf das Energiefeld auswirkt und welches der beste Weg ist, die Ursache nachhaltig zu reparieren.",
            number: "2",
            bulletColor: "#C7EDEF",
            borderColor: "#43C2C8",
        },
        {
            title: "Praktische Ausführung",
            content:
                "Anhand der Analyse und der Simulation beginne ich jetzt mit der Ausführung. Währenddessen kontrolliere ich stetig die Reaktion des Energiefeldes, damit ich da arbeite, wo die Ursachen sind. Denn es geht darum, exakt zu arbeiten, damit man nur an den Prozessen arbeitet, die nicht funktionieren. ",
            number: "3",
            bulletColor: "lightBlue",
            borderColor: "#3A88DF",
        },
        {
            title: "Schlusskontrolle als Basis für die nächste Fernbehandlung",
            content:
                "Ist meine Arbeit abgeschlossen, braucht es einen neutralen, kritischen Blick, der bestätigt, dass die Energiefeld-Instandsetzung sich so auswirkt, wie beabsichtigt. In ca. 5% der Fälle muss leicht nachgebessert werden, das ist normal und kommt vor allem zu Beginn der Fernbehandlung vor. ",
            number: "4",
            bulletColor: "lightPink",
            borderColor: "#E15576",
        },
    ];
    return (
        <>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full pb-24 md:px-20 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        title="Ich schaue die Energiefelder an und repariere sie, wo nötig"
                        hasPreTitle={true}
                        preTitle="Worum geht’s: WIE FUNKTIONIERT DIE FERNBEHANDLUNG"
                        hasText={true}
                        text="Seelische Verletzungen werden repariert, somit funktioniert das Energiefeld besser. So entsteht innere Stärke, um das im Leben zu verändern, was uns belastet."
                        hasSubTitle={false}
                        paddings="px-3 pt-24 "
                        textWidth=" max-w-4xl mx-auto"
                    />
                    <PlayerInPage
                        videoId="8de431550d657fb5441bcf10f445de13"
                        thumbnail="/images/thumbnails/wieSieThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-yellow -mb-[0.1rem] ">
                <Triangles buttomToTop={false} backgroundColor="bg-turquoise" />
            </div>

            <div className="bg-turquoise flex justify-center">
                <div className="container w-full  px-3   flex-col justify-center items-center gap-6 inline-flex">
                    <Text
                        title="Ich lese im Energiefeld, wie andere in einem Buch"
                        hasSubTitle={true}
                        subTitle="Dein Energiefeld ist im Gleichgewicht oder eben nicht"
                        hasText={true}
                        paragraphs={[
                            "Aus deinem Energiefeld kann ich sofort lesen, warum seelische Verletzungen entstanden sind und welche Symptome sie ausgelöst haben. Ich weiss, was zu tun ist, um die Ursachen zu lösen.",
                            "Ich verfüge über eine angeborene, sekundenschnelle Gabe, durch die ich Energiefelder, und auch komplexe Zusammenhänge und Funktionsstörungen in kürzester Zeit präzise erkennen und die nötige Reparatur daraus ableiten kann. Meine Arbeit war schon immer von grösster Sorgfalt und Präzision geprägt.",
                            "Meine Wahrnehmung habe ich seit meiner Kindheit, sie ist für mich genauso selbstverständlich wie die Begabung eines Naturtalents für Kunst. In mehr als 25 Jahren praktischer Erfahrung habe ich kontinuierlich an meinen Fähigkeiten gearbeitet und sie verfeinert, um Menschen auf nachhaltige Weise zu unterstützen und zu helfen.",
                        ]}
                        paddings="px-3 lg:px-74 py-30 w-full md:px-20"
                        leading="leading-10 lg:leadin-[48px]"
                        leadingText="lg:leading-8.5 leading-7"
                        hasReadMore={true}
                        paragraphSlice={2}
                    />
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white flex justify-center">
                <div className="container w-full md:px-2 px-3 lg:px-20  flex-col justify-center items-center gap-6 inline-flex">
                    <SideBySideText
                        reverse={true}
                        elementRight={
                            <Text
                                hasSubTitle={true}
                                subTitle="Auch wenn du weit weg bist"
                                title="Erkennen der Energiefelder"
                                hasText={false}
                                paddings="px-8 lg:w-1/2 text-centar"
                                titleSize=" text-xl3 lg:text-[55px] leading-8  lg:leading-20"
                                subTitleSize="text center text-xl lg:text-xl3 "
                                hasPretitle={false}
                            />
                        }
                        paddings="space-y-10 lg:space-y-0 md:px-0 py-30 px-0 "
                        elementLeft={
                            <div className="">
                                <PlayerInPage
                                    videoId="d9cd38d905cc2c3c90d20325aef36355"
                                    thumbnail="/images/thumbnails/wieSieThumbnail2.jpg"
                                />
                            </div>
                        }
                        backgroundColor="bg-white"
                    />
                </div>
            </div>
            <div className="lg:flex w-full">
                <HalfCard
                    backgroundColor="bg-black"
                    textColor="text-white"
                    title="Gespräche"
                    subTitle="Herkömmlicher Weg:"
                    titleDescription=" Ich kann heute sagen, dass auch die besten Gespräche nicht in der Lage sind, ein Energiefeld zu reparieren."
                    firstButtonText="Gespräch über verletzte Energiefelder"
                    buttonBorderColor="border border-white"
                    secondButtonText="Antworten, weitere Gespräche"
                    text="Meine langjährige Erfahrung zeigt: Ist dein Energiefeld geschwächt, hast du unzählige Fragen und bist ständig auf der Suche nach Antworten."
                    img="/Icons/tangled.svg"
                />
                <HalfCard
                    backgroundColor="bg-yellow"
                    textColor="text-black pt-3"
                    title="Fernbehandlung"
                    subTitle="Neuer Weg:"
                    titleDescription="Meine Arbeit setzt da an, wo Gespräche und Verhaltensänderung nicht helfen."
                    firstButtonText="Ich repariere verletzte Energiefelder"
                    buttonBorderColor="border border-black"
                    secondButtonText="Kraft zur Veränderung!"
                    text="Warum? Weil du durch das Aufbauen von innerer Stärke und Klarheit die Antworten in dir selbst findest. Die Dringlichkeit persönlicher Fragen lässt nach, wenn die Energiefelder instandgesetzt sind."
                    img="/Icons/blackLine.svg"
                />
            </div>

            <div className="bg-white w-full  px-6 lg:px-20 py-20 flex-col gap-6 inline-flex">
                <div className=" text-center text-black text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14">
                    Die 4 täglichen Schritte der Fernbehandlung
                </div>

                <div className="hidden lg:block -mb-[0.4rem]">
                    <Timeline content={timeline} lineColor="#F1F1F1" />
                    <div className="flex justify-center py-5">
                        <Button
                            backgroundColor="bg-black"
                            size={ButtonDark.args?.size}
                            text="Jetzt buchen"
                            as="a"
                            href="/de/bestellen"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title:
                                        "Die 4 täglichen Schritte der Fernbehandlung",
                                    section_index: "5",
                                    cta_text: "Jetzt buchen",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="lg:hidden block -mb-[0.4rem]">
                    <Timeline
                        content={timeline}
                        lineColor="#F1F1F1"
                        layout="1-column-right"
                    />
                    <div className="py-5 md:text-center">
                        <Button
                            backgroundColor="bg-black"
                            size={ButtonDark.args?.size}
                            text="Jetzt buchen"
                            as="a"
                            href="/de/bestellen"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title:
                                        "Die 4 täglichen Schritte der Fernbehandlung",
                                    section_index: "5",
                                    cta_text: "Jetzt buchen",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="">
                <Triangles buttomToTop={false} backgroundColor="bg-blue" />
            </div>
            <div className="bg-blue flex justify-center">
                <div className="container w-full  px-3  py-20 flex-col gap-6 inline-flex">
                    <div className="flex justify-center items-center">
                        <Text
                            title="Jetzt reinhören in die Videopodcasts zur Fernbehandlung"
                            paddings=" "
                            paragraphs={[
                                "Möchtest du erfahren, warum ich die Fernbehandlung anbiete? Dann sind diese kostenlosen Videos genau das Richtige für dich. Ich versuche die Fernbehandlung, ihre Vorteile und Mechanismen auf eine verständliche Weise aufzuzeigen und berichte über Praxisbeispiele.",
                            ]}
                            hasSubTitle={false}
                        />
                    </div>
                    <div className="">
                        <MasterclassStats
                            videos_duration="4 hrs 50 min"
                            module_count="5"
                            videos_count="150"
                            buttonColor="bg-white"
                            buttonTextColor="text-blue"
                        />
                    </div>
                    <InfoModal
                        onClose={() => setOpenModal(false)}
                        opened={openModal}
                        size="full"
                        paddings="lg:px-5 lg:pb-7 px-0"
                        fullScreen={false}
                    >
                        <PlayerInPage videoId={id} thumbnail={thumbnail} />
                    </InfoModal>

                    <p className="lg:text-xl1 text-lg font-normal leading-8.5 md:leading-7  ">
                        Schau dir 8 Videos aus der Masterclass an. Lust auf mehr? Dann
                        klicke unten auf den Button und tauche tiefer in die Masterclass
                        ein.
                    </p>
                    <div className="lg:grid md:grid md:grid-cols-3 text-center gap-6 grid-cols-4">
                        {moduleVideosWithSub?.slice(0, 8).map((video: Video) => {
                            return (
                                <div key={video.id}>
                                    <button
                                        type="button"
                                        className="curor-pointer text-left"
                                        onClick={() => {
                                            setId(video.id);
                                            setThumbnail(video.thumbnail);
                                            setOpenModal(true);
                                        }}
                                    >
                                        <SmallVideoCard
                                            img={video.thumbnail}
                                            duration={formatDuration(video.duration)}
                                            free={true}
                                            title={video.title}
                                        />
                                    </button>
                                </div>
                            );
                        })}
                    </div>

                    <div className="flex mx-auto justify-center">
                        <Button
                            backgroundColor={LongButton.args?.backgroundColor}
                            border={LongButton.args?.border}
                            hasIcon={LongButton.args?.hasIcon}
                            textSize={LongButton.args?.textSize}
                            textColor={LongButton.args?.textColor}
                            size={LongButton.args?.size}
                            paddings="py-4  px-3 lg:px-5"
                            rounded={LongButton.args?.rounded}
                            text="BRING MICH ZUR MASTERCLASS"
                            as="a"
                            href="/de/masterclass#masterclassSection"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title:
                                        "Jetzt reinhören in die Videopodcasts zur Fernbehandlung",
                                    section_index: "6",
                                    cta_text: "BRING MICH ZUR MASTERCLASS",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="bg-blue">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container w-full py-10 px-3 md:px-5 lg:px-20  flex-col justify-center items-center gap-6 inline-flex">
                    <SliderNoArrows
                        paginationColor="#FFF"
                        contentEl={
                            <div className="flex justify-center items-center">
                                {shuffle(testimonials?.testimonials)?.map(
                                    (testimonial) => {
                                        return (
                                            <SwiperSlide key={testimonial.testimonial}>
                                                <Testimonial
                                                    backgroundColor={
                                                        TestemonialBlackImg?.args
                                                            ?.backgroundColor
                                                    }
                                                    differentTextColor={
                                                        TestemonialBlackImg?.args
                                                            ?.differentTextColor
                                                    }
                                                    hasImage={testimonial.hasImage}
                                                    text={testimonial?.testimonial}
                                                    icon={TestemonialBlackImg.args?.icon}
                                                    textColor={
                                                        TestemonialBlackImg?.args
                                                            ?.textColor
                                                    }
                                                    name={testimonial?.name}
                                                    hasDescription={false}
                                                    wordsInDifferentColor={[""]}
                                                    hasReadMore={true}
                                                />
                                            </SwiperSlide>
                                        );
                                    },
                                )}
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-black -mb-[0.1rem]">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full py-10 px-3  md:px-0 flex-col justify-center items-center gap-6 inline-flex">
                    <SideBySideText
                        backgroundColor="bg-turquoise"
                        elementLeft={
                            <>
                                <div className="flex justify-center">
                                    <Image
                                        alt=""
                                        width={200}
                                        height={200}
                                        src="/images/stamp.svg"
                                    />
                                </div>
                            </>
                        }
                        elementRight={
                            <div>
                                <Text
                                    title="Ich biete die 30-Tage-Geld-zurück-Garantie an."
                                    hasPretitle={false}
                                    hasSubTitle={false}
                                    hasText={false}
                                    paddings="px-5 lg:px-0"
                                    titlePlacement="lg:text-start text-center"
                                    leading="leading-9"
                                />
                                <div className="mt-5 flex justify-center md:justify-start lg:justify-start">
                                    <Button
                                        backgroundColor={"bg-black"}
                                        border={ButtonDark.args?.border}
                                        rounded={ButtonDark.args?.rounded}
                                        text="Erfahre mehr"
                                        size={ButtonDark.args?.size}
                                        as="a"
                                        href="/de/30-tage-geld-zuruck-garantie"
                                        onClick={() => {
                                            sendGTMEvent({
                                                event: "cta_click",
                                                section_title:
                                                    "Ich biete die 30-Tage-Geld-zurück-Garantie an.",
                                                section_index: "8",
                                                cta_text: "Erfahre mehr",
                                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/30-tage-geld-zuruck-garantie`,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-turquoise -mb-[0.2rem]">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="container w-full py-16 px-3 gap-6 md:px-5 grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2">
                {statistics.map((stat) => {
                    return (
                        <div key={stat.text}>
                            <StatisticCard
                                number={stat.number}
                                numberColor={stat.numberColor}
                                text={stat.text}
                            />
                        </div>
                    );
                })}
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterOrange.args?.backgroundColor}
                        buttonText="Jetzt buchen"
                        hasCheckbox={NewsletterOrange.args?.hasCheckbox}
                        hasDescription={NewsletterOrange.args?.hasDescription}
                        hasInput={NewsletterOrange.args?.hasInput}
                        hasSubText={NewsletterOrange.args?.hasSubText}
                        title="Warte nicht länger - pack es an!"
                        description="Meine Arbeit hat das Ziel, dir nachhaltig in deine natürlich Kraft und Stärke zu helfen. Veränderung ist nur durch Stärke möglich und dazu braucht es funktionierende Energiefelder."
                        buttonAs="a"
                        href="/de/bestellen"
                        buttonPaddings="py-4 px-6"
                        paddings="px-3 py-25 lg:px-80 lg:py-25 md:px-20"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Warte nicht länger - pack es an!",
                                section_index: "10",
                                cta_text: "Jetzt buchen",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
